import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import Package from '~/package.json'

async function getAvailableScripts (cityId, executedScripts)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId, 'remote-scripts')
    const response = await axios.post(url, {clientVersion: Package.version, userUuid: LocalStorageUtils.userUuid, executedScripts})

    return response.data
}

export default { getAvailableScripts }


// WEBPACK FOOTER //
// ./src/services/remoteScripts.js